import { render, staticRenderFns } from "./BasicMediaInfo.vue?vue&type=template&id=614d87f0&scoped=true&"
import script from "./BasicMediaInfo.vue?vue&type=script&lang=js&"
export * from "./BasicMediaInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicMediaInfo.vue?vue&type=style&index=0&id=614d87f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d87f0",
  null
  
)

export default component.exports